










import { Component, Vue } from 'vue-property-decorator';
import { StoryUser } from '../StoryUser'
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import { globalUC } from '../UserCache'
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';             // @ is an alias to /src


@Component({
  name: 'Pose',
  components: { ModalWrapperComponent }
})
export default class PoseView extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public storyTellerId: string

  public get loading(): boolean { return this.$store.state.loading }
  public get isAuthenticated(): boolean { return this.$store.getters.isAuthenticated }
  public get user(): StoryUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }

  // public functions available to the html template
  public async onModalShowChangeStoryStartForm(componentName: string, showing: boolean, submittedStory: boolean): Promise<void> {
    if (!showing) {
      try { await this.$router.push({ name: 'home' }) } catch (Error) {}
    }
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    // @ts-ignore: because segment analytics is loaded in head script
    window.analytics.page(this.$options.name)

    // get code from URL
    this.storyTellerId = this.$route.params.storyTellerId
    let storyTeller: StoryUser = null

    if (this.isAuthenticated) {
      const user: StoryUser = await globalUC.get(this.userId, true)
      utils_auth.saveAuthStuffToStoreAndLocalStorage(user, null)
      if (this.storyTellerId) storyTeller = await globalUC.get(this.storyTellerId, true) 
    }

    // show the pose question box
    if (this.user) {
      if (storyTeller) (this.$refs.StoryStartFormModalComponent as ModalWrapperComponent).show(`Pose a Question To ${storyTeller.firstName}`, 'lg', { circleUser: storyTeller, circleId: storyTeller.circleId, storyTellerId: this.storyTellerId })
      else (this.$refs.StoryStartFormModalComponent as ModalWrapperComponent).show(`Pose a Question`, 'lg', null)
    } else {
      try { await this.$router.push({ name: 'home' }) } catch (Error) {}
    }

  }

}

